import React, { useEffect, useState } from "react";
import Select from "react-select";
import { BiMinus } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";
import { Disclosure } from "@headlessui/react";
import { Link, useNavigate } from "react-router-dom";
import {
  ChangeTitle,
  decrypt,
  formatPrice,
  getEncodedCookie,
  selectFormStyle,
  selectStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { IoClose } from "react-icons/io5";
import Slider from "react-slick";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import DOMPurify from "dompurify";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { getCookie, setCookie } from "../../helpers/CookieComponent";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValues = {
  name: "",
  designation: "",
  organizationName: "",
  emailId: "",
  fixedLineNumber: "",
  mobileNumber: "",
  subjectMatterRequirement: "",
  serviceOfInterest: "",
  date: "",
  time: "",
  preferableModeToConnect: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required("Name is required")
    .matches(onlyAlphabet, "Name is not valid"),
  designation: Yup.string().trim().required("Select designation"),
  organizationName: Yup.string()
    .trim()
    .required("Organization's name is required"),
  emailId: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  fixedLineNumber: Yup.string()
    .trim()
    .required("Fixed line number is required")
    .matches(onlyIntRegExp, "Line Number is not valid")
    .min(10, "Line number is not valid")
    .max(16, "Line number is not valid"),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  subjectMatterRequirement: Yup.string()
    .trim()
    .required("Select subject matter requirement"),
  serviceOfInterest: Yup.string()
    .trim()
    .required("Select service of interest"),
  date: Yup.string().trim().required("Date is required"),
  time: Yup.string().trim().required("Time is required"),
  preferableModeToConnect: Yup.string()
    .trim()
    .required("Select preferable mode to connect"),
});

const Advisory = () => {
  ChangeTitle("Advisory");
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("INR");
  const [currencyList, setCurrencyList] = useState([]);
  const [chooseServicesList, setChooseServicesList] = useState([]);
  const [chooseUsList, setChooseUsList] = useState([]);
  const [planAdvisoryList, setPlanAdvisoryList] = useState([]);
  const [planResearchList, setPlanResearchList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [serviceOfInterestList, setServiceOfInterestList] = useState([]);
  const [leaderList, setLeaderList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [faqsList, setFaqsList] = useState([]);
  const [openIndex, setOpenIndex] = useState(null); // State to track which accordion is open
  const auth = decrypt(getCookie("token")) || "";

  // Accordion open verify function
  const isOpen = (index) => openIndex === index;

  // Accordion toggle function
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index)); // Toggle or close the accordion
  };

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        name: values.name,
        designationId: values.designation,
        organizationsName: values.organizationName,
        email: values.emailId,
        fixedLineNumber: values.fixedLineNumber,
        mobileNumber: values.mobileNumber,
        subjectMatterRequirementId: values.subjectMatterRequirement,
        serviceOfInterestId: values.serviceOfInterest,
        callTime: String(values.date + values.time),
        connectionMode: values.preferableModeToConnect,
      };

      const response = await postData(
        "advisory/getintouch/save",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Designation API Call
  const viewDesignationList = async () => {
    const param = {};
    var response = await postData("designation/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.designationName,
        };
      });
      setDesignationList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Subject matter API Call
  const viewSubjectList = async () => {
    const param = {};
    var response = await postData(
      "subjectmatterrequirement/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.subjectMatterRequirementName,
        };
      });
      setSubjectList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Service Of Interest API Call
  const viewServiceOfInterestList = async () => {
    const param = {};
    var response = await postData(
      "serviceofinterest/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.serviceOfInterestName,
        };
      });
      setServiceOfInterestList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Choose Services API Call
  const viewChooseServicesList = async (type) => {
    const param = {
      type: type,
    };
    var response = await postData(
      "servicesandchooseus/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const apiData = data.map((data) => {
        return {
          id: data._id,
          title: data.title,
          description: data.description,
        };
      });
      if (type === "services") {
        setChooseServicesList(apiData);
      }
      if (type === "chooseus") {
        setChooseUsList(apiData);
      }
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Currency API Call
  const viewCurrencyList = async () => {
    const param = {};
    // var response = await postData("country/list", param, apiHeader(false));
    var response = await postData("currency/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;

      const currencyData = data.map((data) => {
        return {
          id: data._id,
          value: data.countryDetail.currency,
          label: `${data.countryDetail.currencyName} (${data.countryDetail.currencySymbol}) - ${data.countryDetail.currency}`,
          currencySymbol: data.countryDetail.currencySymbol,
          currency: data.countryDetail.currency,
        };
      });

      setCurrencyList(currencyData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Choose Services API Call
  const viewPlanList = async (type) => {
    const param = {
      currency: type,
    };
    var response = await postData(
      "advisoryplan/list/currency",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const planAdvisoryData = data
        .filter((data) => {
          return data.type === "advisory";
        })
        
        .map((data) => {
          return {
            id: data._id,
            price: data.price && formatPrice(data.price, selectedCountry),
            category: data.category,
            currency: data.currency,
            subject: data.subjectCovered,
            deliverables: data.deliverables,
            modeOfDelivery: data.modeOfDelivery,
            creditsForNextSubscription: data.creditsForNextSubscription,
          };
        });
      const planResearchData = data
        .filter((data) => {
          return data.type === "research";
        })
        .map((data) => {
          return {
            id: data._id,
            price: data.price && formatPrice(data.price, selectedCountry),
            category: data.category,
            currency: data.currency,
            subject: data.subjectCovered,
            deliverables: data.deliverables,
            modeOfDelivery: data.modeOfDelivery,
            creditsForNextSubscription: data.creditsForNextSubscription,
          };
        });
      setPlanResearchList(planResearchData);
      setPlanAdvisoryList(planAdvisoryData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Faqs API Call
  const viewFaqsList = async () => {
    const param = {
      type: "advisory",
    };
    var response = await postData("faq/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const faqsData = data.map((data) => {
        return {
          id: data._id,
          question: data.question,
          answer: data.answer,
        };
      });
      setFaqsList(faqsData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Leaders API Call
  const viewLeaderList = async () => {
    const param = {
      type: "leader",
      offset: 0,
      limit: 0,
      term: "",
      sort: "",
      sortBy: "",
    };
    var response = await postData(
      "advisoryleaderandteam/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setLeaderList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // Teams API Call
  const viewTeamList = async () => {
    const param = {
      type: "team",
      offset: 0,
      limit: 0,
      term: "",
      sort: "",
      sortBy: "",
    };
    var response = await postData(
      "advisoryleaderandteam/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setTeamList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewPlanList(selectedCountry);
  }, [selectedCountry]);

  useEffect(() => {
    viewDesignationList();
    viewSubjectList();
    viewServiceOfInterestList();
    viewChooseServicesList("services");
    viewChooseServicesList("chooseus");
    viewCurrencyList();
    viewFaqsList();
    viewLeaderList();
    viewTeamList();
    setCookie("a-plan-currency", "INR", {});
    setCookie("a-plan-currency-s", "₹", {});
  }, []);

  // Opem Modal Popup Form Function
  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
  };
  // Close Modal Popup Form Function
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    formik.resetForm();
  };

  // Setting for all slider
  const advisoryPricingPlanSettings = {
    slidesPerRow: 1,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    // autoplay: true,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const researchPricingPlanSettings = {
    slidesPerRow: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: false,
    // autoplay: true,
  };
  const leaderSettings = {
    slidesPerRow: 1,
    slidesToShow: leaderList.length === 1 ? 1 : 2,
    slidesToScroll: 1,
    infinite: leaderList.length > 1,
    swipeToSlide: leaderList.length > 1,
    arrows: false,
    // autoplay: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: leaderList.length === 1 ? 1 : 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: leaderList.length === 1 ? 1 : 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const teamSettings = {
    slidesPerRow: 1,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: false,
    // autoplay: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Plan Buy Function
  const buyPlan = async (data) => {
    setCookie("a-planbillingId", data.id, {});

    const param = {
      planId: data.id,
      promoCode: "",
      currency: data.currency || "INR",
    };

    var response = await postData(
      "private/advisoryplanpurchase/preview",
      param,
      apiHeader(false)
    );

    console.log("plan detail billing", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      navigate("/advisory/billing");
    } else {
      toasterrormsg(response.data.message);
    }
  };

  return (
    <>
      <ToastContainer />
      {isModalOpen === true && (
        <>
          <div
            onClick={closeModal}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[5%] lg:my-0 relative lg:top-[15%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Get in touch</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter name"
                        id="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.name}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Designation
                      </label>
                      <Select
                        name="designation"
                        id="designation"
                        placeholder="Select designation"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={designationList}
                        value={designationList.find(
                          (item) => item.value === formik.values.designation
                        )}
                        onChange={(e) =>
                          formik.setFieldValue("designation", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formik.touched.designation &&
                        formik.errors.designation && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.designation}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Organization’s name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter organization’s name"
                        id="organizationName"
                        value={formik.values.organizationName}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.organizationName &&
                        formik.errors.organizationName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formik.errors.organizationName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email id
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter email id"
                        id="emailId"
                        value={formik.values.emailId}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.emailId && formik.errors.emailId && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.emailId}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Fixed line number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter fixed line number"
                        id="fixedLineNumber"
                        value={formik.values.fixedLineNumber}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.fixedLineNumber &&
                        formik.errors.fixedLineNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formik.errors.fixedLineNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Mobile number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter mobile number"
                        id="mobileNumber"
                        value={formik.values.mobileNumber}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.mobileNumber &&
                        formik.errors.mobileNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.mobileNumber}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Subject matter requirement
                      </label>
                      <Select
                        name="subjectMatterRequirement"
                        id="subjectMatterRequirement"
                        placeholder="Select subject"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={subjectList}
                        value={subjectList.find(
                          (item) =>
                            item.value ===
                            formik.values.subjectMatterRequirement
                        )}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "subjectMatterRequirement",
                            e.value
                          )
                        }
                        styles={selectFormStyle}
                      />
                      {formik.touched.subjectMatterRequirement &&
                        formik.errors.subjectMatterRequirement && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formik.errors.subjectMatterRequirement}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Service of interest
                      </label>
                      <Select
                        name="serviceOfInterest"
                        id="serviceOfInterest"
                        placeholder="Select service of interest"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={serviceOfInterestList}
                        value={serviceOfInterestList.find(
                          (item) =>
                            item.value === formik.values.serviceOfInterest
                        )}
                        onChange={(e) =>
                          formik.setFieldValue("serviceOfInterest", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formik.touched.serviceOfInterest &&
                        formik.errors.serviceOfInterest && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formik.errors.serviceOfInterest}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Preferred time to call
                      </label>
                      <div className="w-full flex flex-col sm:flex-row justify-between gap-5 md:gap-5">
                        {/* <input type="date" className="sm:w-[50%] form-input" /> */}
                        <input
                          className="sm:w-[50%] md:w-[46%] lg:w-[48%] form-input"
                          type="date"
                          placeholder="Enter date"
                          id="date"
                          value={formik.values.date}
                          onChange={formik.handleChange}
                          onClick={(e) =>
                            e.target.showPicker && e.target.showPicker()
                          }
                        />
                        <input
                          className="sm:w-[50%] md:w-[46%] lg:w-[47%] form-input"
                          type="time"
                          placeholder="Enter time"
                          id="time"
                          value={formik.values.time}
                          onChange={formik.handleChange}
                          onClick={(e) =>
                            e.target.showPicker && e.target.showPicker()
                          }
                        />
                      </div>
                      {(formik.touched.date || formik.touched.time) &&
                        (formik.errors.date || formik.errors.time) && (
                          <div className="mt-2 error-msg">
                            {formik.errors.date || formik.errors.time}
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full mb-[3%] form-input-label required"
                      >
                        Preferable mode to connect
                      </label>
                      <div className="w-full flex flex-row gap-5 md:gap-10 mb-auto">
                        <div className="w-[50%] flex items-center form-checkbox">
                          <input
                            type="radio"
                            name="preferableModeToConnect"
                            value="0"
                            checked={
                              formik.values.preferableModeToConnect === "0"
                            }
                            onChange={() =>
                              formik.setFieldValue(
                                "preferableModeToConnect",
                                "0"
                              )
                            }
                            className="w-[20%] form-input accent-[#2C3451]"
                          />
                          <label htmlFor="" className="w-[80%] checkbox-label">
                            Request a call back
                          </label>
                        </div>
                        <div className="w-[50%] flex items-center form-checkbox">
                          <input
                            type="radio"
                            name="preferableModeToConnect"
                            value="1"
                            checked={
                              formik.values.preferableModeToConnect === "1"
                            }
                            onChange={() =>
                              formik.setFieldValue(
                                "preferableModeToConnect",
                                "1"
                              )
                            }
                            className="w-[20%] form-input accent-[#2C3451]"
                          />
                          <label htmlFor="" className="w-[80%] checkbox-label">
                            Request a virtual meeting
                          </label>
                        </div>
                      </div>
                      {formik.touched.preferableModeToConnect &&
                        formik.errors.preferableModeToConnect && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formik.errors.preferableModeToConnect}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Submit</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full h-max min-h-screen advisory-bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full px-[5%] pt-[5%] advisory-part3 our-services">
            <h1 className="hanson text-center mb-[1%] ap3-h1">Our services</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
            <div className="w-full flex gap-10 flex-wrap justify-center os-main-part">
              {chooseServicesList.map((data) => (
                <div className="h-auto w-full sm:w-[60%] lg:w-[30%] p-[2.5%] sm:p-[1.2%] lg:p-[.8%] osmp-box">
                  <div className="h-full px-[8%] py-[5%] osmpb">
                    <h1 className="mb-[8%]">{data.title}</h1>
                    <div
                      className="px-[5%]"
                      dangerouslySetInnerHTML={{
                        __html: data.description,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full px-[5%] pt-[5%]  advisory-part4 why-choose-us">
            <h1 className="hanson text-center mb-[1%] ap4-h1">
              Why choose us?
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
            <div className="w-full flex gap-10 flex-wrap justify-center wcu-main-part">
              {chooseUsList.map((data) => (
                <div className="h-auto w-full sm:w-[60%] lg:w-[30%] p-[2.5%] sm:p-[1.2%] lg:p-[.8%] wcump-box">
                  <div className="h-full px-[8%] py-[5%] wcumpb">
                    <h1 className="mb-[8%]">{data.title}</h1>
                    <div
                      className="px-[5%]"
                      dangerouslySetInnerHTML={{
                        __html: data.description,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/********************************************/}
          <div className="w-full px-[5%] pt-[5%] gap-10 flex flex-col md:grid grid-cols-1 md:grid-cols-6 lg:grid-cols-4 advisory-part5">
            <div className="realtive col-start-1 col-end-5 z-[11] flex justify-center mb-[5%] items-center gap-5">
              <label className="currencylabel">Currency</label>
              <div className="w-[60%] md:w-[50%] lg:w-[30%] currencyselect">
                <Select
                  name="countryName"
                  id="country"
                  placeholder="Select Country"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={currencyList}
                  value={currencyList.find(
                    (item) => item.value === selectedCountry
                  )}
                  onChange={(e) => {
                    setSelectedCountry(e.value);
                    setCookie("a-plan-currency", e.currency, {});
                    setCookie("a-plan-currency-s", e.currencySymbol, {});
                  }}
                  styles={selectStyle}
                />
              </div>
            </div>
            <div
              className="
            md:col-start-1 md:col-end-5 lg:col-end-4 row-start-2 "
            >
              <h1 className="hanson text-center mb-[1%] ap5-h1">
                Advisory pricing plans
              </h1>
              <img
                className="mb-[5%] md:mb-[2%] mx-auto"
                src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                alt=""
              />
            </div>
            <div className="md:col-start-1 md:col-end-5 lg:col-end-4 row-start-3 w-full mx-auto md:w-full flex md:gap-0 items-center flex-row py-[2%] advisory-plans">
              <Slider
                className="w-full h-full md:w-[90%] py-[1rem] mx-auto cursor-pointer"
                {...advisoryPricingPlanSettings}
              >
                {planAdvisoryList.map((data, i) => (
                  <div className="relative z-[10] w-full h-full flex flex-col justify-between py-[5%] md:py-0 px-[3%] yearlyplan">
                    <div className="w-full">
                      <h1 className="text-center pb-[10%] mb-[5%] hanson">
                        {data.category}
                      </h1>
                      <h2 className="text-center mb-[3%]">
                        {data.currency} {data.price}
                      </h2>
                      <p className="text-center w-full xl:w-[60%] mx-auto">
                        <span>Subject covered:</span>
                        <br />{" "}
                        {data.subject &&
                          data.subject
                            .map((item) => item.serviceName)
                            .join(", ")}
                      </p>
                      <div className="py-[5%] plan-requirment">
                        <h3>Deliverables:</h3>
                        <h4>{data.deliverables}</h4>
                      </div>
                      <div className="py-[5%] plan-requirment">
                        <h3>Mode of delivery:</h3>
                        <h4>{data.modeOfDelivery}</h4>
                      </div>
                      <div className="py-[5%] !border-none plan-requirment">
                        <h3>Credits for next subscription*</h3>
                        <h4>{data.creditsForNextSubscription}</h4>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        if (!auth) {
                          toasterrormsg("Please login first");
                          return false;
                        }
                        buyPlan(data);
                      }}
                    >
                      <button className="w-full py-[5%] plan-btn">Buy</button>
                    </button>
                  </div>
                ))}
              </Slider>
            </div>
            <div className="md:col-start-5 lg:col-start-4 md:col-end-7 lg:col-end-5 row-start-2 row-end-3 w-full">
              <h1 className="hanson text-center mb-[1%] ap5-h1">
                Research pricing plans
              </h1>
              <img
                className="mb-[2%] mx-auto"
                src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                alt=""
              />
            </div>
            <div className="md:col-start-5 lg:col-start-4 md:col-end-7 lg:col-end-5 row-start-3 w-full h-full mx-auto sm:w-[50%] md:w-full flex md:gap-0 items-center flex-col md:flex-row px-[3%] py-[5%] lg:py-[8%] advisory-plans advisory-plans2">
              <Slider
                className="w-full h-full md:w-[90%] py-[1rem] mx-auto cursor-pointer"
                {...researchPricingPlanSettings}
              >
                {planResearchList.map((data) => (
                  <div className="relative z-[11] !w-full h-full flex flex-col justify-between py-[5%] md:py-0 px-[3%] yearlyplan hourlyrate">
                    <div className="w-full">
                      <h1 className="text-center pb-[8%] mb-[5%] hanson">
                        {data.category}
                      </h1>
                      <h2 className="text-center mb-[3%]">
                        {data.currency} {data.price}
                      </h2>
                      <p className="text-center w-full xl:w-[60%] mx-auto">
                        <span>Subject covered:</span>
                        <br />
                        {data.subject &&
                          data.subject
                            .map((item) => item.serviceName)
                            .join(", ")}
                      </p>
                      <div className="py-[5%] plan-requirment">
                        <h3>Deliverables:</h3>
                        <h4>{data.deliverables}</h4>
                      </div>
                      <div className="py-[5%] plan-requirment">
                        <h3>Mode of delivery:</h3>
                        <h4>{data.modeOfDelivery}</h4>
                      </div>
                      <div className="py-[5%] !border-none plan-requirment">
                        <h3>Credits for next subscription*:</h3>
                        <h4>{data.creditsForNextSubscription}</h4>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        if (!auth) {
                          toasterrormsg("Please login first");
                          return false;
                        }

                        buyPlan(data);
                      }}
                      className="w-full py-[5%] plan-btn"
                    >
                      Buy
                    </button>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          {/********************************************/}

          <div className="px-[5%] pt-[5%] advisory-leaders">
            <div className="w-full ml-auto relative al-bg-img">
              <div className="w-full relative z-[2] top-0 py-[4%]">
                <div className="w-full">
                  <h1 className="hanson text-center mb-[1%] ap6-h1 al-h1">
                    Our leaders
                  </h1>
                  <img
                    className="mb-[2%] mx-auto"
                    src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                    alt=""
                  />
                </div>
                {leaderList.length === 1 ? (
                  <div className="w-full  flex justify-center al-boxs mx-auto">
                    <div className="relative z-[2] w-full md:w-[50%] mx-auto px-[2%] pt-[13vw] sm:pt-[10vw] md:pt-[7vw] lg:pt-[5vw] pb-[2%] al-box">
                      <img
                        className="absolute z-[5] ml-[1vw] top-[-10vw] sm:top-[-7vw] md:top-[-5vw] lg:top-[-3vw] w-[20vw] h-[20vw] sm:w-[15vw] sm:h-[15vw] md:w-[10vw] md:h-[10vw] lg:w-[7vw] lg:h-[7vw] xxl:h-[13rem] xxl:w-[13rem] rounded-full object-fill"
                        src={leaderList[0].profileImage}
                        alt=""
                      />
                      <h1 className="mb-[5%] hanson alb-name">
                        {leaderList[0].fullName}
                      </h1>
                      <p
                        className="mb-[3%] alb-desc"
                        dangerouslySetInnerHTML={{
                          __html: leaderList[0].description,
                        }}
                      />
                      {leaderList[0].socialLink && (
                        <a
                          target="_blank"
                          href={leaderList[0].socialLink}
                          className="flex items-center gap-3 alb-link"
                        >
                          <img
                            className="w-[2rem]"
                            src={toAbsoluteUrl(
                              "media/img/icon/social-media/Linkedin2.svg"
                            )}
                            alt=""
                          />
                          <span>{leaderList[0].socialLink}</span>
                        </a>
                      )}
                    </div>
                  </div>
                ) : (
                  <Slider
                    {...leaderSettings}
                    className="w-full md:w-[90%] lg:w-[80%] xl:w-[70%] flex md:flex-row flex-col gap-[15vw] md:gap-20 al-boxs"
                  >
                    {leaderList.map((data, i) => (
                      <div className="relative z-[2] w-full mx-auto md:mx-0 px-[2%] pt-[13vw] sm:pt-[10vw] md:pt-[7vw] lg:pt-[5vw] pb-[2%] al-box">
                        <img
                          className="absolute z-[5] ml-[1vw] top-[-10vw] sm:top-[-7vw] md:top-[-5vw] lg:top-[-3vw] w-[20vw] h-[20vw] sm:w-[15vw] sm:h-[15vw] md:w-[10vw] md:h-[10vw] lg:w-[7vw] lg:h-[7vw] xxl:h-[13rem] xxl:w-[13rem] rounded-full object-fill"
                          src={data.profileImage}
                          alt=""
                        />
                        <h1 className="mb-[5%] hanson alb-name">
                          {data.fullName}
                        </h1>
                        <p
                          className="mb-[3%] alb-desc"
                          dangerouslySetInnerHTML={{
                            __html: data.description,
                          }}
                        />
                        {data.socialLink && (
                          <a
                            target="_blank"
                            href={data.socialLink}
                            className="flex items-center gap-3 alb-link"
                          >
                            <img
                              className="w-[2rem]"
                              src={toAbsoluteUrl(
                                "media/img/icon/social-media/Linkedin2.svg"
                              )}
                              alt=""
                            />
                            <span>{data.socialLink}</span>
                          </a>
                        )}
                      </div>
                    ))}
                  </Slider>
                )}
              </div>
            </div>
          </div>

          <div className="pt-[5%] advisory-team">
              <div className="at-part">
                <div className="w-full">
                  <h1 className="hanson text-center mb-[1%] ap6-h1 at-h1">
                    Our research and advisory team
                  </h1>
                  <img
                    className="mb-[2%] mx-auto"
                    src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                    alt=""
                  />
                </div>
                {teamList.length <= 2 ? (
                  <div style={{ display: "flex", justifyContent: "center", gap: "2rem", flexWrap: "wrap", alignItems: "stretch" }} className="at-boxs">
                    {teamList.map((data, i) => (
                      <div key={i} style={{ maxWidth: "45%" }} className="relative z-[2] px-[2%] pt-[13vw] sm:pt-[10vw] md:pt-[7vw] lg:pt-[5vw] pb-[2%] al-box at-box">
                        <img
                          className="absolute ml-[1vw] top-[-10vw] sm:top-[-7vw] md:top-[-5vw] lg:top-[-3vw] w-[20vw] h-[20vw] sm:w-[15vw] sm:h-[15vw] md:w-[10vw] md:h-[10vw] lg:w-[7vw] lg:h-[7vw] xxl:h-[13rem] xxl:w-[13rem] rounded-full object-fill"
                          src={data.profileImage}
                          alt=""
                        />
                        <h1 className="mb-[5%] hanson alb-name">
                          {data.fullName}
                        </h1>
                        <div
                          className="mb-[3%] alb-desc"
                          dangerouslySetInnerHTML={{
                            __html: data.description,
                          }}
                        />
                        {data.socialLink && (
                          <a
                            target="_blank"
                            href={data.socialLink}
                            className="flex items-center gap-3 alb-link"
                          >
                            <img
                              className="w-[2rem]"
                              src={toAbsoluteUrl(
                                "media/img/icon/social-media/Linkedin2.svg",
                              )}
                              alt=""
                            />
                            <span>{data.socialLink}</span>
                          </a>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <Slider
                    {...teamSettings}
                    className="w-full flex lg:flex-row flex-col gap-[15vw] lg:gap-20 at-boxs"
                  >
                    {teamList.map((data, i) => (
                      <div key={i} className="relative z-[2] px-[2%] pt-[13vw] sm:pt-[10vw] md:pt-[7vw] lg:pt-[5vw] pb-[2%] h-max al-box at-box">
                        <img
                          className="absolute ml-[1vw] top-[-10vw] sm:top-[-7vw] md:top-[-5vw] lg:top-[-3vw] w-[20vw] h-[20vw] sm:w-[15vw] sm:h-[15vw] md:w-[10vw] md:h-[10vw] lg:w-[7vw] lg:h-[7vw] xxl:h-[13rem] xxl:w-[13rem] rounded-full object-fill"
                          src={data.profileImage}
                          alt=""
                        />
                        <h1 className="mb-[5%] hanson alb-name">
                          {data.fullName}
                        </h1>
                        <div
                          className="mb-[3%] alb-desc"
                          dangerouslySetInnerHTML={{
                            __html: data.description,
                          }}
                        />
                        {data.socialLink && (
                          <a
                            target="_blank"
                            href={data.socialLink}
                            className="flex items-center gap-3 alb-link"
                          >
                            <img
                              className="w-[2rem]"
                              src={toAbsoluteUrl(
                                "media/img/icon/social-media/Linkedin2.svg",
                              )}
                              alt=""
                            />
                            <span>{data.socialLink}</span>
                          </a>
                        )}
                      </div>
                    ))}
                  </Slider>
                )}
              </div>
          </div>
          <div className="p-[5%] w-full faqs">
            <div className="w-full">
              <h1 className="hanson text-center mb-[1%] ap6-h1">FAQ’s</h1>
              <img
                className="mb-[2%] mx-auto"
                src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                alt=""
              />
            </div>
            <div className="w-full md:w-[70%] mx-auto flex flex-col gap-5 mb-[5%] faqs">
              {faqsList.map((data, index) => (
                <div
                  key={index}
                  className={
                    isOpen(index) ? "p-[2%] faqs-box-active" : "p-[2%] faqs-box"
                  }
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="flex w-full !text-start justify-between"
                  >
                    <span>{data.question}</span>
                    {isOpen(index) ? (
                      <BiMinus className="faqs-minus" />
                    ) : (
                      <BsPlusLg className="faqs-plus" />
                    )}
                  </button>
                  {isOpen(index) && (
                    <div className="px-4 pb-2 pt-4 text-sm text-gray-500">
                      <p
                        className=""
                        dangerouslySetInnerHTML={{ __html: data.answer }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="w-full mb-[10%] md:mb-[5%] advisory-contact">
              <div className="w-full mb-[5%]">
                <h1 className="hanson text-center mb-[1%] contact-h1">
                  Contact us
                </h1>
                <img
                  className="mb-[2%] mx-auto"
                  src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                  alt=""
                />
              </div>
              <div className="w-full md:w-[70%] flex justify-center mx-auto flex-col md:flex-row gap-16 md:gap-10">
                <div className="relative w-full sm:w-[70%] mx-auto md:w-[50%] md:mx-0 px-[5%] sm:px-[3%] md:px-[2.5%] lg:px-[1.5%] ac-box">
                  <div className="w-full relative top-[-1.3rem] sm:top-[-1.5rem] md:top-[-20%]">
                    <img
                      className="mb-[7%] w-[12%] ac-icon"
                      src={toAbsoluteUrl("media/img/icon/contact/location.svg")}
                      alt="Phone Icon"
                    />
                    <h1 className="mb-[2%] ac-title">Location</h1>
                    <h1 className="ac-data">
                      GCC Law Help, 112/11, Kamdhenu, Hariom Nagar, Mulund East,
                      Mumbai Maharashtra, India, 400081
                    </h1>
                    <h1 className="ac-data">+91 9819222127</h1>
                  </div>
                </div>
                <div className="relative w-full sm:w-[70%] mx-auto md:w-[50%] md:mx-0 px-[5%] sm:px-[3%] md:px-[2.5%] lg:px-[1.5%] ac-box">
                  <div className="relative top-[-1.3rem] sm:top-[-1.5rem] md:top-[-20%] w-full">
                    <img
                      className="mb-[7%] w-[15%] ac-icon"
                      src={toAbsoluteUrl("media/img/icon/contact/mail.svg")}
                      alt="Email Icon"
                    />
                    <h1 className="mb-[2%] ac-title">Sales enquiry</h1>
                    <h1 className="ac-data">gcchelplaw@gmail.com</h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full mb-[5%] advisory-part2">
              <div className="relative md:w-[70%] p-[3%] mx-auto ap2">
                <div className="w-full relative z-[1]">
                  <h1 className="w-full mb-[3%] text-center hanson">
                    Let’s talk
                  </h1>
                  <p className="lg:w-[70%] xl:w-[50%] mb-[5%] mx-auto text-center">
                    We are excited to hear more from you and see how GCC Law
                    Help your business grow.{" "}
                  </p>
                  <div className="w-full flex justify-center">
                    <button
                      onClick={openModal}
                      className="w-max px-[5%] py-[2%] ap2-btn"
                    >
                      Request call back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Advisory;
